import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_METHOD_SEND_MESSAGE } from 'api/notificationManager/methods';

export default class SendMessageRequest extends WsBaseRequest {
  constructor(data: any) {
    super(API_METHOD_SEND_MESSAGE, data);
  }
}
